import $ from "jquery";
import "datatables.net-bs4";
import "datatables.net-bs4/css/dataTables.bootstrap4.css";
/* import language from "./italian.json"; */

$.extend(true, $.fn.dataTable.defaults, {
    //language,
    lengthChange: false,
    info: false
});
